import React from "react";

const LogoMarquee = ({ logos, speed = 30 }) => {
  const items = [...logos, ...logos];
  return (
    <div
      className="logo-marquee"
      style={{ "--marquee-speed": `${speed}s` }}
    >
      <div className="logo-marquee__track">
        {items.map((logo, i) => (
          <div className="logo-marquee__item" key={`${logo.src}-${i}`}>
            <img src={logo.src} alt={logo.alt} loading="lazy" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LogoMarquee;
